import { reFetchAllDatasetsOnOptimize } from 'api/dataset/dataset.api'
import { getRoute } from 'helpers/route.helper/route.helper'
import authStore from 'store/auth/auth'
import { chartStore } from 'store/chart/chart'
import elplanStore from 'store/elplan/elplan'
import filterStore, { debugFilterStore } from 'store/filter/filter'
import uiConfigStore from 'store/uiConfig/uiConfig'
import zoomStore, { setZoom } from 'store/zoom/zoom'
import { getLogHistory, printLogHistory } from 'utils/log/log'
import { snapshot } from 'valtio'

window.dev.getUiConfigStore = () => snapshot(uiConfigStore)
window.dev.getAuthStore = () => snapshot(authStore)
window.dev.getZoomStore = () => snapshot(zoomStore)
window.dev.getElplanStore = () => snapshot(elplanStore)
window.dev.reFetchAllDatasetsOnOptimize = reFetchAllDatasetsOnOptimize
window.dev.setZoom = setZoom
window.dev.getChartStore = () => snapshot(chartStore)
window.dev.getFilterStore = () => snapshot(filterStore)
window.dev.getDebugFilterStore = () => snapshot(debugFilterStore)
window.dev.setGrouping = (str: string) => {
  const route = getRoute()
  filterStore.groupingPerRoute[route] = str
}
window.dev.printLogHistory = printLogHistory
window.dev.getLogHistory = getLogHistory
window.dev.getActiveTagsForUiConfig = () => snapshot(filterStore.activeTagsForUiConfig)
